import React, { useRef, useState } from "react";
import { UrlApi } from "../../services/apirest";
import {
    Alert,
    Autocomplete,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
    TextField,
    Typography,
} from "@mui/material";
import { logEventos } from "../../services/services";

function DialogCambiarDestino(props) {
    const { abrir, datosRow, destinos, onClose } = props;

    const [destino, setDestino] = useState(null);
    const [procesando, setProcesando] = useState(false);
    const [confirmacion, setConfirmacion] = useState("");
    const [error, setError] = useState("");
    const [avisos, setAvisos] = useState([]);
    const procesandoRef = useRef(false);

    const opciones = (destinos || []).filter(
        (sucursal) => Number(sucursal.id) !== Number(datosRow.destino)
    );

    const cerrar = () => {
        if (procesandoRef.current) return;
        if (onClose) onClose();
    };

    const cambiarDestino = async (confirmarSaldo = false) => {
        if (!destino || procesandoRef.current) return;

        procesandoRef.current = true;
        setProcesando(true);
        setError("");

        let cerrarAlTerminar = false;

        try {
            const res = await fetch(
                UrlApi +
                "/viajes_abastecimiento/" +
                datosRow.id_viaje +
                "/cambiar-destino",
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        destino: destino.id,
                        usuario: localStorage.getItem("user"),
                        confirmar_saldo: confirmarSaldo,
                    }),
                }
            );

            const data = await res.json().catch(() => null);

            if (res.status === 409 && data?.codigo === "CONFIRMACION_SALDO_DESTINO") {
                setConfirmacion(data.mensaje);
                return;
            }

            if (!res.ok || !data?.ok) {
                setConfirmacion("");
                setError(data?.mensaje || "No se pudo cambiar el destino.");
                return;
            }

            logEventos(
                "Cambiar destino del viaje",
                "Viajes",
                "Se cambió el destino del viaje " +
                datosRow.id_viaje +
                " a " +
                destino.nombre,
                localStorage.getItem("user")
            );

            if (Array.isArray(data.avisos) && data.avisos.length > 0) {
                setConfirmacion("");
                setAvisos(data.avisos);
            } else {
                cerrarAlTerminar = true;
            }
        } catch (err) {
            console.error(err);
            setError("No se pudo conectar con el servidor. Intentá nuevamente.");
        } finally {
            procesandoRef.current = false;
            setProcesando(false);
        }

        if (cerrarAlTerminar && onClose) onClose();
    };

    const mostrarAvisos = avisos.length > 0;

    return (
        <Dialog open={abrir} onClose={cerrar} fullWidth maxWidth="sm">
            <DialogTitle>
                {mostrarAvisos
                    ? "Destino cambiado"
                    : "Cambiar destino del viaje N° " + datosRow.id_viaje}
            </DialogTitle>

            <DialogContent>
                {mostrarAvisos ? (
                    <Stack spacing={1} sx={{ mt: 1 }}>
                        {avisos.map((aviso) => (
                            <Alert severity="warning" key={aviso}>
                                {aviso}
                            </Alert>
                        ))}
                    </Stack>
                ) : (
                    <Stack spacing={2} sx={{ mt: 1 }}>
                        <Typography>
                            Destino actual: <b>{datosRow.nombre_sucursal}</b>
                        </Typography>

                        <Autocomplete
                            size="small"
                            options={opciones}
                            value={destino}
                            autoHighlight
                            noOptionsText="Sucursal inexistente"
                            isOptionEqualToValue={(opcion, valor) => opcion.id === valor.id}
                            getOptionLabel={(opcion) => opcion.id + "-" + opcion.nombre}
                            onChange={(event, valor) => {
                                setDestino(valor);
                                setConfirmacion("");
                                setError("");
                            }}
                            renderInput={(params) => (
                                <TextField {...params} required label="Nuevo destino" />
                            )}
                        />

                        <Alert severity="info">
                            Si el viaje está en curso, avisale al chofer: este cambio no le
                            envía una notificación.
                        </Alert>

                        {confirmacion ? (
                            <Alert severity="warning">{confirmacion}</Alert>
                        ) : null}

                        {error ? <Alert severity="error">{error}</Alert> : null}
                    </Stack>
                )}
            </DialogContent>

            <DialogActions>
                {mostrarAvisos ? (
                    <Button variant="contained" onClick={cerrar}>
                        Entendido
                    </Button>
                ) : (
                    <>
                        <Button onClick={cerrar} disabled={procesando}>
                            Volver
                        </Button>
                        <Button
                            variant="contained"
                            color={confirmacion ? "warning" : "primary"}
                            disabled={!destino || procesando}
                            onClick={() => cambiarDestino(Boolean(confirmacion))}
                        >
                            {procesando
                                ? "Guardando..."
                                : confirmacion
                                    ? "Desviar de todos modos"
                                    : "Cambiar destino"}
                        </Button>
                    </>
                )}
            </DialogActions>
        </Dialog>
    );
}

export default DialogCambiarDestino;